import { DefaultSection } from "../../../../common/components/common/DefaultSection";
import { Persona } from "../../../../common/components/common/Persona/Persona";
import { SectionInfoRow } from "../../../../common/components/common/SectionInfoRow";
import { ItemsList } from "../../../../common/components/itemsList/ItemsList";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { IconType } from "../../../../common/icons/Icon";
import { useAddAdditionalLayoutButton } from "../../../../common/infrastructure/hooks/useAddAdditionalLayoutButton";
import {
  constructMyFamilyEditHref,
  routePaths,
} from "../../../../common/infrastructure/routes/routePaths";
import { dateUtility } from "../../../../common/infrastructure/utilities/dateUtility";
import { IMyFamilyViewModel } from "../models/MyFamilyViewModel";
import styles from "./MyFamilyProfile.module.scss";

interface IMyFamilyProfileProps {
  familyData?: IMyFamilyViewModel;
  isLoading: boolean;
}

export const MyFamilyProfile = ({
  familyData,
  isLoading,
}: IMyFamilyProfileProps) => {
  useAddAdditionalLayoutButton({
    iconType: IconType.EditIcon,
    href: constructMyFamilyEditHref(familyData?.id ?? 0),
    rawPath: routePaths.portalMyFamilyEdit,
    validator: !!familyData?.id && !!familyData?.canEdit,
  });

  return (
    <div className={styles.root}>
      <DefaultSection className={styles.root_title}>
        <div className={styles.root_header_title}>
          <SkeletonItem isLoading={isLoading} value={familyData?.name} />
        </div>
      </DefaultSection>

      <DefaultSection className={styles.root_info_section}>
        <SectionInfoRow
          label={"Отговорник на семейството"}
          data={familyData?.headOfFamilyName ?? "Няма отговорник"}
          isLoading={isLoading}
          skekletonWidth={300}
        />

        <SectionInfoRow
          label={"Общ брой посещения на класове"}
          data={`${familyData?.totalClassesTaken}бр.`}
          isLoading={isLoading}
          skekletonWidth={100}
        />

        <SectionInfoRow
          label={"Създадено на"}
          data={dateUtility.formatDate(familyData?.createdOn)}
          isLoading={isLoading}
          skekletonWidth={150}
        />
      </DefaultSection>

      <ItemsList
        isLoading={isLoading}
        noItemsText="Семейството няма членове. Можете да добавите, като го редактирате."
        className={styles.list}
        title="Членове на семейството"
        tooltip="Можете да добавяте нови членове към семейството, като го редактирате. Отговорникът е отбелязан със звезда."
        numberOfItems={5}
        itemTemplate={(item, index) => {
          return (
            <SkeletonItem
              key={item?.id ?? index}
              className={styles.list_item}
              value={
                <Persona
                  className={styles.list_item}
                  firstName={item?.firstName ?? ""}
                  lastName={item?.lastName ?? ""}
                  star={item?.isHeadOfFamily}
                  id={item?.id ?? 0}
                />
              }
              isLoading={isLoading}
              width={"100%"}
            />
          );
        }}
        items={familyData?.members ?? []}
      />
    </div>
  );
};
